module.exports = __webpack_public_path__ + "static/media/Fred_Bass.7ff42c2f.webp";